export default{
        data() {
            return {
              fields: [
                { key: "name", label: "العنوان" },
                { key: "actions", label: "" }
              ],
              estatesFormSchema: {
                name: {
                  component: "FormInput",
                  key: "name",
                  attrs: {
                    id: "name",
                    label: "العنوان",
                    rules: "required",
                  },
                },
              }
            };
          },
    
}